import React, { useEffect, useState } from 'react';
import Title from '../../components/title/Title';
import avatar from './../../assets/avatares/inteiro_note_preto.png';
import { useSelector } from 'react-redux';

//etapas
import PreCadastro from './etapas/PreCadastro';
import Ativacao from './etapas/Ativacao';
import Completar from './etapas/Completar';

//Css
import './Cadastro.scss';

const Cadastro = props => {

    const profile = useSelector(state => state.auth.profile);

    const [etapa, setEtapa] = useState(1);
    const [subTitulo, setSubTitulo] = useState("Crie sua conta, preencha os campos abaixo.");

    useEffect(() => {
        if (profile._id) {
            switch (profile.status) {
                case 0:
                    setEtapa(2);
                    setSubTitulo("Ative sua conta digitando o código que enviamos pra você");
                    return;
                case 1:
                    setEtapa(3);
                    setSubTitulo("Complete seus dados");
                    return;
                case 2:
                    setEtapa(4);
                    setSubTitulo("Aguarde seu cadastro ser processado");
                    return;
                default:
                    return;
            }
        }
    }, [profile]);

    const renderAviso = () => {
        return (
            <div className="form">
                <form className="formModule branco">
                    <h3 className="tituloEtapa">Seus dados estão em análise</h3>
                    <div className="break"></div>
                    <div className="info">
                        Nós estamos analisando seu cadastro, muito em breve você receberá um e-mail sobre essa análise.
                    </div>
                </form>
            </div>
        )
    }

    return (
        <div className='background cadastroRevendedora'>
            <Title title='Cadastro' subtitle={subTitulo} />
            <div className="container">
                <div className="content">
                    <div className="layout">

                        <div className="avatar">
                            <img src={avatar} alt="leka" />
                        </div>
                        {etapa === 1 && <PreCadastro />}
                        {etapa === 2 && <Ativacao />}
                        {etapa === 3 && <Completar />}
                        {etapa === 4 && renderAviso()}
                    </div>
                </div>
            </div>

        </div>
    )
};

export default Cadastro;
